import { useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { IEmployer } from "../../data_models/employer";
import { FilledButton } from "../common/Button";
import EditOrCreateProjectLightbox from "../lightboxes/projects/EditOrCreateProjectLightbox";
import useMyProjects from "../../hooks/useMyProjects";
import { EProjectStatus, IProject } from "../../data_models/project";
import EmployerProjectsTable from "./EmployerProjectsTable";
import EmployerDashboardOverview from "./EmployerDashboardOverview";
import { EmployerWallet } from "../../data_models/employerWallet";
import useRouting from "../../hooks/useRouting";
import useProjects from "../../hooks/useProjects";


const EmployerDashboard = () => {


    const [employer, setEmployer] = useState<IEmployer | null>(null);
    const [showCreateProjectLightbox, setShowCreateProjectLightbox] = useState(false);


    const [projectDrafts, setProjectDrafts] = useState<IProject[]>([]);
    const [ongoingProjects, setOngoingProjects] = useState<IProject[]>([]);
    const [completedProjects, setCompletedProjects] = useState<IProject[]>([]);



    const { fetchMyProjects } = useProjects();
    const { currentUser, wallet } = useCurrentUser();
    const { goToCreateNewProject } = useRouting();


    useEffect(() => {
        if (currentUser) {
            setEmployer(currentUser as IEmployer);

            const fetchProjects = async () => {
                const projects = await fetchMyProjects(1, 99999);
                setProjectDrafts(projects.filter(project => project.status === EProjectStatus.DRAFT));
                setOngoingProjects(projects.filter(project => (project.status || Infinity) < EProjectStatus.COMPLETED
                    && (project.status || 0) > EProjectStatus.DRAFT));
                setCompletedProjects(projects.filter(project => (project.status || 0) >= EProjectStatus.COMPLETED));
            }

            fetchProjects();
        }
    }, [currentUser]);


    return (
        <div className="p-4 max-w-7xl mx-auto">
            <div className="flex flex-row justify-between items-center">
                {(employer?.employerName?.length || 0) > 0
                    ? <h3 className="font-bold">Let's start building, {((currentUser as IEmployer).employerName)}!</h3>
                    : <h3 className="font-bold">Let's start building!</h3>}

                {/* <FilledButton
                    onClick={goToCreateNewProject}>
                    Create new Project
                </FilledButton> */}

            </div>
            <div className="mt-14">
                <EmployerDashboardOverview
                    projectDrafts={projectDrafts}
                    projectsOngoing={ongoingProjects}
                    projectsCompleted={completedProjects}
                />
            </div>

            {/* Projects Section */}
            <div className="mt-14">
                <EmployerProjectsTable header="Ongoing Projects" projects={[...ongoingProjects, ...projectDrafts]} />
            </div>
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-14">
                <div className="flex flex-col space-y-6">

                </div>

            </div> */}

            {showCreateProjectLightbox && <EditOrCreateProjectLightbox onClose={() => setShowCreateProjectLightbox(false)} />}
        </div >
    );
};

export default EmployerDashboard;